export default __webpack_public_path__ + "static/media/logo.bd017043.svg";